import {
  FETCH_FILES_FAILURE,
  FETCH_FILES_REQUEST,
  FETCH_FILES_SUCCESS,
  FETCH_STARRED_FILES,
  FETCH_SHARED_FILES,
  FETCH_DELETED_FILES,
  UPDATE_HOME_FILES,
  UPDATE_STARRED_FILES,
  UPDATE_DELETED_FILES,
} from "./FileTypes";

const initialState = {
  loading: false,
  files: [],
  starredFiles: [],
  deletedFiles: [],
  sharedFiles: [],
  error: "",
};

const FileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FILES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        files: action.payload,
      };

    case FETCH_FILES_FAILURE:
      return {
        ...state,
        loading: false,
        files: [],
        error: action.payload,
      };

    case FETCH_STARRED_FILES:
      return {
        ...state,
        loading: false,
        starredFiles: action.payload,
        error: "",
      };
    case FETCH_SHARED_FILES:
      return {
        ...state,
        loading: false,
        sharedFiles: action.payload,
        error: "",
      };

    case FETCH_DELETED_FILES:
      return {
        ...state,
        loading: false,
        deletedFiles: action.payload,
        error: "",
      };

    case UPDATE_HOME_FILES:
      return {
        ...state,
        files: action.payload,
      };

    case UPDATE_STARRED_FILES:
      return {
        ...state,
        starredFiles: action.payload,
      };

    case UPDATE_DELETED_FILES:
      return {
        ...state,
        deletedFiles: action.payload,
      };
    default:
      return state;
  }
};

export default FileReducer;
